// extracted by mini-css-extract-plugin
export default {"assigneesList":"Assignees-module__assigneesList__itUQ3RF","assigneeNameLabel":"Assignees-module__assigneeNameLabel__RBQTnQp"};